import { render, staticRenderFns } from "./SaleDownPaymentView.vue?vue&type=template&id=310cd045"
import script from "./SaleDownPaymentView.vue?vue&type=script&lang=js"
export * from "./SaleDownPaymentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports